/**
 * Недавно открытые задачи — пустое состояние палитры (DEV-2049): чаще всего
 * возвращаются к тому, что смотрели минуту назад, и набирать номер заново —
 * лишний круг.
 *
 * localStorage, десять последних: это подсказка, а не история — её не жалко
 * потерять и незачем синхронизировать.
 */
const KEY = 'tracker.recent-issues'
const LIMIT = 10

export interface RecentIssue {
  key: string
  title: string
}

export const recentIssues = (): RecentIssue[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? '[]') as RecentIssue[]

    return Array.isArray(parsed)
      ? parsed.filter((entry) => entry && typeof entry.key === 'string').slice(0, LIMIT)
      : []
  } catch {
    return []
  }
}

export const rememberIssue = (issue: RecentIssue): void => {
  if (!issue.key) return

  try {
    const rest = recentIssues().filter((entry) => entry.key !== issue.key)

    localStorage.setItem(KEY, JSON.stringify([issue, ...rest].slice(0, LIMIT)))
  } catch {
    // Некуда писать — просто не запомнится.
  }
}
